module.exports = __webpack_public_path__ + "media/profile_pictures/profile-picture-3-5d0833eb.jpg";